import { render, staticRenderFns } from "./scroll-rating.vue?vue&type=template&id=ce0bef10"
import script from "./scroll-rating.vue?vue&type=script&lang=js"
export * from "./scroll-rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports